import React, { FC, memo, } from 'react';
import { Form, Input, Popover, Segmented, Slider } from 'antd';
import { SketchPicker } from 'react-color';
import '../style/title_text.less';
// import styles from  '../style/title_text.less';
export interface Props {
    dataField?: any
    index: number
}
interface SetProps {
    dataField?: any
    id?: string
    methods?: any
    selectedInfo?: any
    otherInfo?: any
}

const TitleText: FC<Props> = ({ dataField }) => {
    return (
        <div className={`title-text-container ${dataField.pageStyle}`} >
            <p className="title" style={
                {
                    color: dataField.titleColor,
                    textAlign: dataField.textAlign,
                    fontSize: dataField.fontSize
                }
            }>{dataField.title || '请输入标题'}</p>
        </div>
    )
}

export const TitleTextSet: FC<SetProps> = memo(({ dataField, id, methods }) => {
    return (
        <div className="title-text-set" >
            <Form.Item label="标题" >
                <Input.Group compact>
                    <Input style={{ width: '80%' }} onChange={
                        (e) => {
                            let value = e.target.value
                            // console.log(e)
                            methods.updateModuleData({
                                ...dataField,
                                title: value
                            }, id)
                        }
                    } value={dataField.title} placeholder="请输入标题" />
                    <Popover content={
                        <SketchPicker
                            color={dataField.titleColor}
                            onChange={
                                (e: any) => {
                                    methods.updateModuleData({
                                        ...dataField,
                                        titleColor: e.hex
                                    }, id)
                                }
                            }
                        />
                    } title="" trigger="click">
                        <p className="color-hover" style={
                            {
                                backgroundColor: dataField.descColor
                            }
                        }></p>
                    </Popover>
                </Input.Group>
            </Form.Item>
            <Form.Item label="字体大小">
                <Slider max={60} value={dataField.fontSize} onChange={
                    (e) => {
                        methods.updateModuleData({
                            ...dataField,
                            fontSize: e
                        }, id)
                    }
                } />
            </Form.Item>
            <Form.Item label="对齐方式" >
                <Segmented
                    defaultValue="左对齐"
                    style={{ marginBottom: 8 }}
                    onChange={(value) => {
                        let align = value === '左对齐' ? 'left' : value === '居中' ? 'center' : value === '右对齐' ? 'right' : 'left'
                        methods.updateModuleData({
                            ...dataField,
                            textAlign: align
                        }, id)
                    }}
                    options={['左对齐', '居中', '右对齐']}
                />
            </Form.Item>
        </div>
    )
})

export default TitleText

